import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

const ROWS = ['row1', 'row2', 'row3', 'row4', 'row5', 'row6'];

export const FeatureFaq = () => {
  const { t } = useTranslation('landing');

  return (
    <Box component="section" sx={{ py: { xs: '60px', md: '100px' }, background: '#f8fafc', overflow: 'hidden' }}>
      <Box sx={{ maxWidth: 1440, mx: 'auto', px: { xs: '24px', md: '40px' } }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '62% 35%' }, gap: '3%', alignItems: 'center' }}>
          {/* Visual — LEFT (order 1) */}
          <Box className="omni-feature-visual omni-reveal omni-reveal-delay-1" sx={{ order: { xs: 1, md: 1 } }}>
            <Box className="omni-mockup-frame">
              <Box className="omni-mockup-chrome">
                <Box className="omni-mockup-dots"><span /><span /><span /></Box>
                <Box className="omni-mockup-title">{t('featureFaq.mockup.title')}</Box>
              </Box>
              <Box className="mock-faq">
                {/* Toolbar */}
                <Box className="mock-faq-toolbar">
                  <Box className="mock-faq-toolbar-left">
                    <Typography sx={{ fontWeight: 700, fontSize: 16, color: '#0f1729' }}>
                      {t('featureFaq.mockup.toolbarTitle')}
                    </Typography>
                    <Box className="mock-faq-search">{t('featureFaq.mockup.searchPlaceholder')}</Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: '8px' }}>
                    <Box className="mock-faq-btn" sx={{ border: '1px solid #e2e8f0', color: '#374151', background: '#fff' }}>
                      {t('featureFaq.mockup.batchUpload')}
                    </Box>
                    <Box className="mock-faq-btn" sx={{ background: '#3664D1', color: '#fff' }}>
                      {t('featureFaq.mockup.addNew')}
                    </Box>
                  </Box>
                </Box>

                {/* Table */}
                <Box className="mock-faq-table">
                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: '28%' }}>{t('featureFaq.mockup.headerQuestion')}</th>
                        <th style={{ width: '40%' }}>{t('featureFaq.mockup.headerAnswer')}</th>
                        <th style={{ width: '16%' }}>{t('featureFaq.mockup.headerCategory')}</th>
                        <th style={{ width: '16%' }}>{t('featureFaq.mockup.headerStatus')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ROWS.map((row) => {
                        const status = t(`featureFaq.mockup.${row}.status`);
                        const isActive = status === '已啟用';
                        return (
                          <tr key={row}>
                            <td className="q-col">{t(`featureFaq.mockup.${row}.q`)}</td>
                            <td className="a-col">{t(`featureFaq.mockup.${row}.a`)}</td>
                            <td>
                              <Box className="mock-faq-cat">{t(`featureFaq.mockup.${row}.cat`)}</Box>
                            </td>
                            <td>
                              <Box
                                className="mock-faq-status"
                                sx={{
                                  background: isActive ? '#dcfce7' : '#fef9c3',
                                  color: isActive ? '#166534' : '#854d0e',
                                }}
                              >
                                {status}
                              </Box>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Text — RIGHT (order 2) */}
          <Box className="omni-reveal" sx={{ order: { xs: 2, md: 2 } }}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: 16, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#7c3aed', mb: 2 }}>
              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg>
              {t('featureFaq.label')}
            </Box>
            <Typography variant="h3" sx={{ fontSize: { xs: '1.6rem', md: 'clamp(1.6rem, 3vw, 2.2rem)' }, fontWeight: 800, lineHeight: 1.3, mb: 2, letterSpacing: '-0.3px', color: '#0f1729' }}>
              {t('featureFaq.title')}
            </Typography>
            <Typography sx={{ fontSize: 19, color: '#374151', lineHeight: 1.8, mb: '28px' }}>
              {t('featureFaq.desc')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {['bullet1', 'bullet2', 'bullet3'].map((key) => (
                <Box key={key} sx={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <Box sx={{ width: 24, height: 24, borderRadius: '50%', background: '#7c3aed', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: '2px', fontSize: 15, fontWeight: 700, color: '#fff' }}>&#10003;</Box>
                  <Typography sx={{ fontSize: 18, color: '#374151', lineHeight: 1.5 }}>{t(`featureFaq.${key}`)}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
